import { Bar, BarChart, Tooltip, XAxis, YAxis } from 'recharts';
import styles from '../styles.module.scss';

type Props = {
  totalUserCount: number;
  completedUserCount: number;
  completedUserRate: number;
  highStressUserCount: number;
  highStressUserRate: number;
  pendingUserCount: number;
  pendingUserRate: number;
};

export const OverallProgressCard: React.FC<Props> = ({
  totalUserCount,
  completedUserCount,
  completedUserRate,
  highStressUserCount,
  highStressUserRate,
  pendingUserCount,
  pendingUserRate,
}) => {
  const normalUserCount = completedUserCount - highStressUserCount;

  return (
    <div className={styles.overallProgressCard}>
      <h3 className={styles.title}>全体の進捗</h3>
      <div className={styles.chartContainer}>
        <div>
          <p className={styles.summary}>
            <span className={styles.label}>実施人数</span>
            <span className={styles.mainCount}>{completedUserCount}</span>
            <span className={styles.separator}>/</span>
            <span className={styles.detail}>
              {totalUserCount}人（{completedUserRate}%）
            </span>
          </p>
          <BarChart
            data={[
              {
                name: 'overallProgress',
                normal: normalUserCount,
                highStress: highStressUserCount,
                pending: pendingUserCount,
              },
            ]}
            layout='vertical'
            width={248}
            height={24}
            margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
          >
            <XAxis type='number' hide domain={[0, 'dataMax']} />
            <YAxis type='category' dataKey='name' axisLine={false} tickLine={false} width={0} />
            <Tooltip />
            <Bar
              dataKey='normal'
              stackId='overallProgress'
              className={styles.normalBar}
              barSize={24}
              radius={[4, 0, 0, 4]}
            />
            <Bar
              dataKey='highStress'
              stackId='overallProgress'
              className={styles.highStressBar}
              barSize={24}
            />
            <Bar
              dataKey='pending'
              stackId='overallProgress'
              className={styles.pendingBar}
              barSize={24}
              radius={[0, 4, 4, 0]}
            />
          </BarChart>
          <p className={styles.summary}>
            <span className={styles.group}>
              <span className={styles.detail}>高ストレス者</span>
              <span className={styles.highStressCount}>{highStressUserCount}</span>
              <span className={styles.detail}>人（{highStressUserRate}%）</span>
            </span>
            <span className={styles.group}>
              <span className={styles.detail}>未回答</span>
              <span className={styles.pendingCount}>{pendingUserCount}</span>
              <span className={styles.detail}>人（{pendingUserRate}%）</span>
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};
